import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss']
})
export class CounterComponent {

  @Input()
  counter = {
    first: 0,
    second: 0
  }

  @Output()
  counterChange: EventEmitter<{first: number, second: number}> = new EventEmitter();

  changeCounter(changeType: 'first' | 'second', value) {
    if (changeType === 'second') {
      if (this.counter[changeType] + value < 0) {
        this.counter[changeType] = 9;
      } else if (this.counter[changeType] + value > 9) {
        this.counter[changeType] = 0;
      } else {
        this.counter[changeType] += value;
      }
    } else {
        this.counter[changeType] = this.counter[changeType] + value >= 0 ? this.counter[changeType] += value : 0;
    }
    this.counterChange.emit(this.counter);
  }

}